import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-disc-grp-prod-langs',
  templateUrl: './disc-grp-prod-langs.component.html',
  styleUrls: ['./disc-grp-prod-langs.component.css']
})
export class DiscGrpProdLangsComponent implements OnInit {
    discGrpProdKeyno;

    public inputListLanguages: InputLanguageItem[] = [];

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.discGrpProdKeyno = this.stateService.getStateParams()['discgrpprod_keyno'];
    }

    private async loadLanguages(): Promise<void> {
        if (!!this.discGrpProdKeyno) {
            this.inputListLanguages = await this.datatask.Post(3115, { discgrpprod_keyno: this.discGrpProdKeyno });
        }
    }

    public async saveChanges() {
        if (!!this.inputListLanguages) {
            try {
                this.saving = true;

                await this.datatask.Post(3116, { records: this.inputListLanguages });

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadLanguages();
    }

    ngOnInit() {
        this.init();
    }
}

interface InputLanguageItem {
    discgrpprod_keyno: number;
    discgrpprod_name: string;
    language_id: string;
    language_name: string;
    orderby: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('discGrpProdLangs', {
//        templateUrl: 'views/components/views/discGrpProdLangs/discGrpProdLangs.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'discGrpProdLangsService', function ($stateParams, stateService, discGrpProdLangsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let discGrpProdKeyno = $stateParams.discgrpprod_keyno;

//            vm.model = {
//                inputListLanguages: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadLanguages() {
//                vm.model.inputListLanguages = await discGrpProdLangsService.listLanguages({ discgrpprod_keyno: discGrpProdKeyno });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                discGrpProdLangsService.saveObj({ records: vm.model.inputListLanguages }).then(function () {
//                    stateService.back();
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadLanguages();
//            }

//            // #endregion ON INIT FUNCTION
//        }]
//    });
//})();
